import * as $ from 'jquery';
export const forgotPassword = () => {
    $('.forgot-password-js').on('click', function () {
        $('#login_form').addClass('hidden');
        $('#resend_email_form').addClass('hidden');
        $('#forgot_password_form').removeClass('hidden');
    });

    $('.back-to-login-js').on('click', function () {
        $('#forgot_password_form').addClass('hidden');
        $('#resend_email_form').addClass('hidden');
        $('#login_form').removeClass('hidden');
    });
}